'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require('react-router');

var _mobxReact = require('mobx-react');

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ImpersonatePage = (_dec = (0, _mobxReact.inject)('SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = function (_Component) {
  _inherits(ImpersonatePage, _Component);

  function ImpersonatePage() {
    _classCallCheck(this, ImpersonatePage);

    return _possibleConstructorReturn(this, (ImpersonatePage.__proto__ || Object.getPrototypeOf(ImpersonatePage)).apply(this, arguments));
  }

  _createClass(ImpersonatePage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.impersonateUser();
    }
  }, {
    key: 'impersonateUser',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var SessionStore, _browserHistory$getCu, query, impersonatedUserId;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                SessionStore = this.props.SessionStore, _browserHistory$getCu = _reactRouter.browserHistory.getCurrentLocation(), query = _browserHistory$getCu.query, impersonatedUserId = (0, _get3.default)(query, 'impersonated_user_id');

                if (impersonatedUserId) {
                  _context.next = 4;
                  break;
                }

                _reactRouter.browserHistory.replace('/');
                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return SessionStore.hijackSession(impersonatedUserId);

              case 6:
                _reactRouter.browserHistory.replace(query.next || '/');

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function impersonateUser() {
        return _ref.apply(this, arguments);
      }

      return impersonateUser;
    }()
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Grid2.default,
        { fluid: true, className: 'page-impersonate' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Impersonating user...' }),
        _react2.default.createElement(
          'div',
          { className: 'wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'flex-between' },
            _react2.default.createElement('div', { className: 'user-secret' }),
            _react2.default.createElement(
              'h1',
              null,
              'Impersonating user...'
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ImpersonatePage;
}(_react.Component)) || _class) || _class);
var _default = ImpersonatePage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ImpersonatePage, 'ImpersonatePage', '/app/src/components/pages/ImpersonatePage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/pages/ImpersonatePage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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